import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material';

import { DbmListModule } from '../dbm-list/dbm-list.module';
import { DbmList2Module } from '../dbm-list2/dbm-list2.module';
import { DbmEditModule } from '../dbm-edit/dbm-edit.module';
import { DbmMasterDetailListComponent } from './dbm-master-detail-list.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatCheckboxModule,

        DbmListModule,
        DbmList2Module,
        DbmEditModule
    ],
    declarations: [DbmMasterDetailListComponent],
    entryComponents: [DbmMasterDetailListComponent],
    exports: [DbmMasterDetailListComponent]
})
export class DbmMasterDetailListModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-master-detail-list/dbm-master-detail-list.module.ts